import { useField } from 'formik';

import { FormControl } from '@@/form-components/FormControl';
import { TextArea } from '@@/form-components/Input/Textarea';

export function MachinesField() {
  const [field, meta] = useField<string>('machines');

  return (
    <FormControl
      label="Machines"
      inputId="kubesolo-machines"
      required
      errors={
        meta.touched && meta.error ? (
          <span className="whitespace-pre-line">{meta.error}</span>
        ) : undefined
      }
    >
      <TextArea
        id="kubesolo-machines"
        name={field.name}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        className="min-h-[150px] resize-y"
        placeholder={
          '10.0.1.11, 10.0.1.12:2222\n10.0.2.1 - 10.0.2.20\nedge-03.factory.local'
        }
        data-cy="kubesolo-machines-input"
      />
      <span className="small text-muted">
        IP addresses or DNS names with an optional :port, separated by new
        lines, commas or spaces. Add a range of IPv4 addresses with a hyphen,
        e.g. 10.0.2.1 - 10.0.2.20, or a CIDR block, e.g. 10.0.2.0/28
      </span>
    </FormControl>
  );
}
